import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-custom-switch',
  templateUrl: './custom-switch.component.html',
  styleUrls: ['./custom-switch.component.css']
})
export class CustomSwitchComponent {
  @Input() valor: boolean;
  @Input() identificador: string = '0';
  @Output() valorChange = new EventEmitter<boolean>();

  get nombre(): string {
    return this.valor ? 'Activo' : 'Inactivo';
  }


  onChange(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    console.log('Switch changed:', isChecked);
    this.valorChange.emit(isChecked);
  }
}